import { useState, useMemo } from 'react';
import { validateGradeEchelon } from '../utils/validation';
import { GradeData, Profession } from '../types';

export function usePrimeValidation(
  selectedGrade: number | null, 
  selectedEchelon: number,
  grades: GradeData[],
  selectedProfession: Profession
) {
  const [validationErrors, setValidationErrors] = useState<Record<string, string[]>>({});

  // Calculate valid echelons for the selected grade
  const validEchelons = useMemo(() => {
    if (!selectedGrade) return [];
    const currentGrade = (grades || []).find(g => g.id === selectedGrade);
    return currentGrade ? currentGrade.echelons.map(e => e.echelon) : [];
  }, [selectedGrade, grades]);

  // Validate grade and echelon selection
  const gradeEchelonValidation = useMemo(() => {
    return validateGradeEchelon(selectedGrade, selectedEchelon, validEchelons);
  }, [selectedGrade, selectedEchelon, validEchelons]);

  return {
    validationErrors,
    gradeEchelonValidation,
    setValidationErrors
  };
}